export const Identity = (encoded: Uint8Array): Uint8Array => encoded
